import "./news.scss";
import MediaPagination from "../../components/media-pagination";
import HeadlineSection from "../../components/headline-section";
import NewsCard from "../../components/news-card";
import news1 from "../../assets/home/news1.jpg";
import news2 from "../../assets/home/news2.jpg";
import news3 from "../../assets/home/news3.jpg";
import news4 from "../../assets/home/news4.jpg";

const News = () => {
  return (
    <>
    <div className="news-page">
        <div>
          <HeadlineSection headline="أخـبــــارنــا" />
          <p className="description-title"> لحظة بلحظة... </p>
       </div>

        <div className="all-news">
             <NewsCard newsImage={news1}
              newsTitle={"مشروع الموجه الشخصي"}
               newsDate={"17 أكتوبر 2020"} 
               newsDescription={"برنامج لتنمية مهارات أعضاء هيئة التدريس في الجامعات في مجال التوجيه الشخصي والأكاديمي في الجامعات السعودية ، ورفع مستوى وعي طلاب الجامعات بمنهجيات"}/>
               <NewsCard newsImage={news2}
               newsTitle={"مشروع الموجه الشخصي"}
                newsDate={"17 أكتوبر 2020"} 
                newsDescription={"برنامج لتنمية مهارات أعضاء هيئة التدريس في الجامعات في مجال التوجيه الشخصي والأكاديمي في الجامعات السعودية ، ورفع مستوى وعي طلاب الجامعات بمنهجيات"}/>
                <NewsCard newsImage={news3}
              newsTitle={"مشروع الموجه الشخصي"}
               newsDate={"17 أكتوبر 2020"} 
               newsDescription={"برنامج لتنمية مهارات أعضاء هيئة التدريس في الجامعات في مجال التوجيه الشخصي والأكاديمي في الجامعات السعودية ، ورفع مستوى وعي طلاب الجامعات بمنهجيات"}/>
               <NewsCard newsImage={news4}
              newsTitle={"مشروع الموجه الشخصي"}
               newsDate={"17 أكتوبر 2020"} 
               newsDescription={"برنامج لتنمية مهارات أعضاء هيئة التدريس في الجامعات في مجال التوجيه الشخصي والأكاديمي في الجامعات السعودية ، ورفع مستوى وعي طلاب الجامعات بمنهجيات"}/>
        
        </div>
        <div className="all-news">
             <NewsCard newsImage={news1}
              newsTitle={"مشروع الموجه الشخصي"}
               newsDate={"17 أكتوبر 2020"} 
               newsDescription={"برنامج لتنمية مهارات أعضاء هيئة التدريس في الجامعات في مجال التوجيه الشخصي والأكاديمي في الجامعات السعودية ، ورفع مستوى وعي طلاب الجامعات بمنهجيات"}/>
               <NewsCard newsImage={news2}
               newsTitle={"مشروع الموجه الشخصي"}
                newsDate={"17 أكتوبر 2020"} 
                newsDescription={"برنامج لتنمية مهارات أعضاء هيئة التدريس في الجامعات في مجال التوجيه الشخصي والأكاديمي في الجامعات السعودية ، ورفع مستوى وعي طلاب الجامعات بمنهجيات"}/>
                <NewsCard newsImage={news3}
              newsTitle={"مشروع الموجه الشخصي"}
               newsDate={"17 أكتوبر 2020"} 
               newsDescription={"برنامج لتنمية مهارات أعضاء هيئة التدريس في الجامعات في مجال التوجيه الشخصي والأكاديمي في الجامعات السعودية ، ورفع مستوى وعي طلاب الجامعات بمنهجيات"}/>
               <NewsCard newsImage={news4}
              newsTitle={"مشروع الموجه الشخصي"}
               newsDate={"17 أكتوبر 2020"} 
               newsDescription={"برنامج لتنمية مهارات أعضاء هيئة التدريس في الجامعات في مجال التوجيه الشخصي والأكاديمي في الجامعات السعودية ، ورفع مستوى وعي طلاب الجامعات بمنهجيات"}/>
        
        </div>


        <div className="my-pagination">
              <MediaPagination/>
        </div>

    </div>
  
    </>
  );
};

export default News;